import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#9F8852',
        },
    },
    components: {
        MuiInput: {
            styleOverrides: {
                input: {
                    height: '100%',
                },
            },
        },
    },
});

export default theme;
